import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["value"];
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-attention-14px" }, null, -1);
const _hoisted_3 = {
    key: 0,
    class: "multiselect-value__dropdown"
};
const _hoisted_4 = { class: "multiselect-value__list" };
const _hoisted_5 = { class: "multiselect-value__scroll" };
const _hoisted_6 = ["title", "onClick"];
const _hoisted_7 = { class: "multiselect-value__item__label" };
const _hoisted_8 = {
    key: 0,
    class: "multiselect-value__selected-options"
};
const _hoisted_9 = { class: "multiselect-value__scroll customScrollBar" };
const _hoisted_10 = ["title", "onClick"];
const _hoisted_11 = { class: "multiselect-value__update-button" };
import { ref, computed, watch, inject } from 'vue';
import CheckBox from '@/components/_atoms/CheckBox.vue';
import IconBase from '@/assets/vue-icons/IconBase.vue';
import IconTrash from '@/assets/vue-icons/icons/Trash.vue';
import { useClickOutside } from '@/features/AudienceManager/composables/useClickOutside';
import { useStore } from 'vuex';
import { useAudienceManager } from '@/features/AudienceManager/composables/useAudienceManager';
import { formatLabels } from '@/features/AudienceManager/utils/format';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MultiSelect',
    setup(__props) {
        const store = useStore();
        const groupIndex = inject('groupIndex');
        const isInclude = inject('isInclude');
        const groupType = inject('groupType');
        const { draftCondition, selectedCriteriaDetails, keepFooterLoadingDuringInteraction } = useAudienceManager(isInclude, groupIndex);
        const dropdownRef = ref(null);
        const selectedOptions = ref([...draftCondition.value?.value]);
        const { isDropdownOpen } = useClickOutside(dropdownRef, () => {
            setDropdownVisibility(false);
        });
        const getOptions = computed(() => selectedCriteriaDetails.value?.options || {});
        const selectedValues = computed(() => selectedOptions.value.map(key => getOptions.value[key]).filter(Boolean));
        const selectedOptionsDetails = computed(() => selectedOptions.value.map(key => ({ key, label: getOptions.value[key] })).filter(option => option.label));
        const updateOption = (optionKey) => {
            if (selectedOptions.value.includes(optionKey)) {
                removeSelection(optionKey);
            }
            else {
                selectedOptions.value.push(optionKey);
            }
            updateDraftCondition();
        };
        const setDropdownVisibility = (isVisible) => {
            isDropdownOpen.value = isVisible;
            keepFooterLoadingDuringInteraction();
        };
        const removeSelection = (keyToRemove) => {
            selectedOptions.value = selectedOptions.value.filter(optionsKey => optionsKey !== keyToRemove);
            updateDraftCondition();
        };
        const updateDraftCondition = () => {
            store.dispatch('audienceManager/updateDraftCondition', {
                groupType,
                groupIndex,
                data: { value: [...selectedOptions.value] },
            });
        };
        watch(draftCondition, newValue => {
            selectedOptions.value = [...newValue.value];
        }, { immediate: true, deep: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                ref_key: "dropdownRef",
                ref: dropdownRef,
                class: "multiselect-value"
            }, [
                _createElementVNode("input", {
                    value: _unref(formatLabels)(selectedValues.value),
                    type: "text",
                    class: "multiselect-value__input",
                    readonly: "",
                    onClick: _cache[0] || (_cache[0] = ($event) => (setDropdownVisibility(true)))
                }, null, 8, _hoisted_1),
                _hoisted_2,
                (_unref(isDropdownOpen))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getOptions.value, (optionLabel, optionKey) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: optionKey,
                                        title: optionLabel,
                                        class: "multiselect-value__item multiselection",
                                        onClick: ($event) => (updateOption(optionKey))
                                    }, [
                                        _createVNode(CheckBox, {
                                            class: "multiselection-content",
                                            checked: selectedOptions.value.includes(optionKey)
                                        }, null, 8, ["checked"]),
                                        _createElementVNode("div", _hoisted_7, _toDisplayString(optionLabel), 1)
                                    ], 8, _hoisted_6));
                                }), 128))
                            ]),
                            (selectedOptions.value.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('audiences.selected')), 1),
                                    _createElementVNode("div", _hoisted_9, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedOptionsDetails.value, (selectedOption, key) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: key,
                                                title: selectedOption.label,
                                                class: "multiselect-value__selected",
                                                onClick: _withModifiers(($event) => (removeSelection(String(selectedOption.key))), ["stop"])
                                            }, [
                                                _createElementVNode("span", null, _toDisplayString(selectedOption.label), 1),
                                                _createVNode(IconBase, {
                                                    color: "#EC3942",
                                                    class: "trash-icon"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(IconTrash)
                                                    ]),
                                                    _: 1
                                                })
                                            ], 8, _hoisted_10));
                                        }), 128))
                                    ]),
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("button", {
                                            class: "btn",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (setDropdownVisibility(false)))
                                        }, _toDisplayString(_ctx.$t('audiences.select')), 1)
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 512));
        };
    }
});
